import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const renderError = (heading: string, body: string) => {
  const errorDiv = document.createElement('div');
  errorDiv.style.cssText =
    'position: fixed; top: 0; left: 0; right: 0; z-index: 9999; padding: 20px; background: white; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';

  const h = document.createElement('h2');
  h.style.cssText = 'color: red; margin: 0 0 10px 0;';
  h.textContent = heading;

  const pre = document.createElement('pre');
  pre.style.cssText =
    'color: red; text-align: left; margin: 0; padding: 10px; background: #f8f8f8; overflow: auto; max-height: 200px;';
  pre.textContent = body;

  const button = document.createElement('button');
  button.style.cssText = 'margin-top: 10px; padding: 5px 10px;';
  button.textContent = 'Dismiss';
  button.addEventListener('click', () => errorDiv.remove());

  errorDiv.appendChild(h);
  errorDiv.appendChild(pre);
  errorDiv.appendChild(button);
  document.body.appendChild(errorDiv);
};

window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global error:', { message, source, lineno, colno, error });
  renderError(
    'Application Error',
    `Error: ${message}\nSource: ${source}\nLine: ${lineno}\nColumn: ${colno}\nStack: ${error?.stack || ''}`
  );
  return false;
};

window.onunhandledrejection = (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  renderError(
    'Unhandled Promise Rejection',
    `Error: ${event.reason}\nStack: ${event.reason?.stack || ''}`
  );
};

// Loading state
const loadingDiv = document.createElement('div');
loadingDiv.style.cssText =
  'position: fixed; top: 0; left: 0; right: 0; bottom: 0; display: flex; justify-content: center; align-items: center; background: white; z-index: 9999;';
loadingDiv.innerHTML = `
  <div style="text-align: center;">
    <div style="width: 50px; height: 50px; border: 5px solid #f3f3f3; border-top: 5px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite;"></div>
    <p style="margin-top: 20px; color: #666;">Loading application...</p>
  </div>
  <style>
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
`;
document.body.appendChild(loadingDiv);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  loadingDiv.remove();
} catch (error) {
  console.error('Error during app initialization:', error);
  loadingDiv.innerHTML = '';

  const wrap = document.createElement('div');
  wrap.style.cssText = 'text-align: center; padding: 20px;';

  const h1 = document.createElement('h1');
  h1.style.color = 'red';
  h1.textContent = 'Failed to start the application';

  const pre = document.createElement('pre');
  pre.style.cssText =
    'color: red; text-align: left; margin: 20px; padding: 10px; background: #f8f8f8; overflow: auto; max-height: 200px;';
  pre.textContent = String(error);

  const button = document.createElement('button');
  button.style.cssText =
    'padding: 10px 20px; background: #3498db; color: white; border: none; border-radius: 4px; cursor: pointer;';
  button.textContent = 'Reload App';
  button.addEventListener('click', () => window.location.reload());

  wrap.append(h1, pre, button);
  loadingDiv.appendChild(wrap);
}

if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
} else {
  reportWebVitals();
}
